import React from 'react';

interface Props {
  style?: React.CSSProperties;
}

export function BorderBottom({ style = {} }: Props) {
  return <div style={{ borderBottom: '1px dashed #d8d8df', ...style }} />;
}
